<template>
        <div class="hubspot-disabled-modal">
            <transition name="fade">
                <div :class="['hubspot-disabled-modal__notification_popup', { 'show' : hubSpotDisabledPopupVisible }]" v-if="hubSpotDisabledPopupVisible">
                    <span class="icon-cancel" @click="hideModal"></span>
                    <h1 class="hubspot-disabled-modal__title" v-html="$t('HubspotDisabled.title')"></h1>
                    <span class="hubspot-disabled-modal__notification_popup-text" v-html="getHubspotDisabledMessage"></span>
                </div>
            </transition>
            <button class="hubspot-disabled-modal__button hubspot-disabled-modal__button--disabled" @click="showHubSpotDisabledPopup">
                <img src="@/assets/images/chatbot/hubspot/button.svg" :alt="$t('ChatBotCombo.hubspot_disabled_alt_image_text')">
            </button>
        </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'HubspotDisabledPopup',
        computed: {
            ...mapGetters({
                hubSpotDisabledPopupVisible: 'Hubspot/hubSpotDisabledPopupVisible'
            }),
            getHubspotDisabledMessage () {
                return this.$t('HubspotDisabled.chat_disabled_message',
                               { acceptCookies: `<a style="color: #e47700; text-decoration: underline;" href="javascript: Cookiebot.show()">${this.$t('HubspotDisabled.accept_cookies')}</a>` })
            }
        },
        methods: {
            hideModal () {
                this.$store.dispatch('Hubspot/hideHubSpotDisabledPopup')
            },
            showHubSpotDisabledPopup () {
                this.$store.dispatch('Hubspot/showHubSpotDisabledPopup')
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.4s ease, transform 0.4s ease;
        transform: translateX(0);
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: translateX(10px)
    }
    .hubspot-disabled-modal {
        position: fixed;
        bottom: 25px;
        right: 25px;
        z-index: 9990;

        &__button {
            appearance: none;
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
            margin: 0;
            align-self: flex-end;
            font-family: Nunito-Regular, sans-serif;
            position: fixed;
            right: 20px;
            bottom: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-content: flex-end;
            z-index: 9990;
            gap: 1rem;

            &--disabled {
                opacity: 0.7;
            }

            img {
                box-shadow: 0 0 6px 0 #00000040;
                border-radius: 50%;
            }
        }


        &__notification_popup {
			display: none;
            position: fixed;
            flex-direction: column;
            bottom: 110px;
            right: 10px;
            width: 270px;
            background-color: $white;
            font-size: 1.5rem;
            font-family: Nunito-Regular, sans-serif;
            color: $black;
            text-align: center;
            padding: 20px 10px;
            z-index: 10001;
            box-shadow: 2px 2px 4px 0px #00000040;

			&.show {
				display: flex;
			}
        }

        &__title {
            font-size: 1.8rem;
            margin: 12px;
        }
    }
    .icon-cancel {
		color: $black;
		margin: 5px;
		position: absolute;
		top: 2px;
		right: 2px;
		font-size: 2.4rem;
    }
</style>
